import { resolveVfaMapValues } from "../../statistics_map/ThresholdTestUtil";
import test_entry_config from "../../../test_entry/config/test_entry_config.json";

export function buildGpaValues(tests) {
  const rows = tests.map((test) => {
    const resolved = resolveVfaMapValues(test);
    if (!resolved) return null;
    return {
      eye: test.eye,
      points: test.points,
      testType: test.testType,
      patient: test.patient,
      testBehaviour: test.testBehaviour,
      version: test.version,
      startDate: test.startDate,
      blindSpotTotal: test.blindSpotTotal,
      blindSpotSeen: test.blindSpotSeen,
      fpFnInfo: test.fpFnInfo,
      ...resolved,
    };
  });

  const unavailable = rows.filter((row) => row === null).length;
  return { values: unavailable > 0 ? [] : rows, unavailable };
}

export function calculateDeviationParameters(values) {
  if (values.length < 2) return;
  const baselineTests = values.slice(0, 2);
  const baselinePdAvarageValues = baselineTests[0].npd.map((val, index) =>
    Math.ceil((val + baselineTests[1].npd[index]) / 2),
  );
  const testValues = values.slice(2);
  const tempDeviations = testValues.map((test) => {
    return test.npd.map((value, index) => {
      return value - baselinePdAvarageValues[index];
    });
  });
  const limits = test_entry_config.pdValue95PercentileValuesForGCPM;
  const limitsKeys = Object.keys(limits);
  const deteriorationMaps = tempDeviations.map((devMap) => {
    return baselinePdAvarageValues.map((val, index) => {
      if (!limitsKeys.includes(val.toString())) {
        return 0;
      }
      if (devMap[index] < limits[val.toString()]) {
        return 1;
      }
      return 0;
    });
  });
  return {
    baselinePdAvarageValues: baselinePdAvarageValues,
    deviationMaps: tempDeviations,
    deteriorationMaps: deteriorationMaps,
  };
}

export function calculateDeviationProbabilityMaps(deteriorationMaps) {
  return deteriorationMaps.map((_, index) => {
    const prevMaps = deteriorationMaps.slice(0, index + 1).slice(-3);

    return prevMaps.reduce((sumArray, currentArray) => {
      return sumArray.map((value, index) => value + currentArray[index]);
    });
  });
}
